
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28","fill":"#282828","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.273 12.031c0-.604-.49-1.094-1.093-1.094H6.914a1.094 1.094 0 100 2.188H18.18c.604 0 1.093-.49 1.093-1.094zM6.914 15.313a1.094 1.094 0 100 2.187h6.842a1.094 1.094 0 000-2.188H6.914z"}}),_c('path',{attrs:{"d":"M9.486 25.813H5.828a2.19 2.19 0 01-2.187-2.188V4.375a2.19 2.19 0 012.187-2.188h13.447a2.19 2.19 0 012.188 2.188v6.727a1.094 1.094 0 002.187 0V4.375A4.38 4.38 0 0019.275 0H5.828a4.38 4.38 0 00-4.375 4.375v19.25A4.38 4.38 0 005.828 28h3.658a1.094 1.094 0 000-2.188z"}}),_c('path',{attrs:{"d":"M25.586 15.835a3.285 3.285 0 00-4.64-.001l-6.005 5.991a1.094 1.094 0 00-.274.457l-1.307 4.305a1.094 1.094 0 001.338 1.372l4.415-1.223c.182-.05.347-.147.48-.28l5.993-5.98a3.285 3.285 0 000-4.641zm-7.334 8.87l-2.221.615.65-2.14 4.052-4.043 1.547 1.547-4.028 4.02zm5.788-5.777l-.212.211-1.547-1.547.211-.21a1.095 1.095 0 011.548 1.546zM18.18 6.563H6.914a1.094 1.094 0 100 2.187H18.18a1.094 1.094 0 100-2.188z"}})])
          )
        }
      }
    